import { render, staticRenderFns } from "./RestoreAccountModal.vue?vue&type=template&id=382af76a&scoped=true&"
import script from "./RestoreAccountModal.vue?vue&type=script&lang=js&"
export * from "./RestoreAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./RestoreAccountModal.vue?vue&type=style&index=0&id=382af76a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382af76a",
  null
  
)

export default component.exports